<template>
  <div class="production-unit">
    <navbar></navbar>
    <div class="box">
      <header v-if="!loading && productionUnit">
        <h1>{{ productionUnit.name }}</h1>
        <p>{{ productionUnit.description }}</p>
        <img src="@/assets/icons/transmitter.png" height="40" alt="">&nbsp;&nbsp;
        <img src="@/assets/icons/production-switcher.png" height="40" alt="">&nbsp;&nbsp;
        <img src="@/assets/icons/graphics.png" height="40" alt="">
        <br>
        <span>
          <i v-if="productionUnitState === 'offline'">Unit Offline</i>
          <i v-if="productionUnitState === 'online'">Unit Online</i>
          <i v-if="productionUnitState === 'starting'">Unit Starting</i>
          <i v-if="productionUnitState === 'stopping'">Unit Stopping</i>
        </span>
        <div class="start-stop">
          <button v-if="productionUnitState === 'offline'" @click="startMachines">Start unit</button>
          <button v-else-if="productionUnitState === 'online'" @click="stopMachines">Stop unit</button>
          <div v-else>
            <loading></loading>
          </div>
        </div>
      </header>
      <loading v-if="loading"></loading>
      <div v-else>
        <div class="machine" v-for="machine in productionUnit.machines" :key="machine.id">
          <div class="icon">
            <img v-if="machine.type === 'production_switcher'" src="@/assets/icons/production-switcher.png" alt="">
            <img v-if="machine.type === 'graphics'" src="@/assets/icons/graphics.png" alt="">
            <img v-if="machine.type === 'transmitter'" src="@/assets/icons/transmitter.png" alt="">
          </div>
          <div class="info">
            <div class="name">{{ machine.name }}</div>
            <div class="description">
              <circle-state :service="machine.service" :state="machine.state"></circle-state>
              <span>{{ startCase(machine.state) }}</span>
            </div>
          </div>
          <div class="access">
            <button v-if="machine.service === 'WS'" @click="access(machine)" :disabled="machine.state !== 'available'">Access via Workspaces</button>
            <button v-if="machine.service === 'EC2'" @click="access(machine)" :disabled="machine.state !== 'running'">Access via RDP</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Start error modal -->
    <modal v-if="startingMachinesModal" :title="'Error: Starting machines'" :ok="'Ok'" @ok="startingMachinesModal = false">
      <p>We encountered a problem during machines startup. Some might have been able to start.</p>
      <small><b>ERROR DETAIL</b></small>
      <pre>
{{ startingMachinesError }}        
      </pre>
    </modal>

    <!-- Stop error modal -->
    <modal v-if="stoppingMachinesModal" :title="'Error: Stopping machines'" :ok="'Ok'" @ok="stoppingMachinesModal = false">
      <p>We encountered a problem during machines shutdown. Some might have been able to stop.</p>
      <small><b>ERROR DETAIL</b></small>
      <pre>
{{ stoppingMachinesError }}        
      </pre>
    </modal>

    <!-- Access modal -->
    <modal v-if="accessModal" :title="accessModalTitle" :cancel="'Dismiss'" @cancel='accessModal = false'>
      <div>
        <!-- <p>You have to install Microsoft's remote desktop client software.
          <br>It's built-in in Windows with the "Remote Desktop Connection" app.
          On a Mac you'd have to install it from <a href="https://apps.apple.com/us/app/microsoft-remote-desktop-10/id1295203466?mt=12" target="_blank">there</a>.
        </p> -->
        <div>
          <h3>Access Credentials</h3>
          <table>
            <thead>
              <tr v-if="accessModalMachine.service === 'EC2'">
                <td>Host</td>
                <td class="copiable">{{ accessModalMachine.publicIp }}</td>
              </tr>
              <tr v-else>
                <td>Registration code</td>
                <td class="copiable">{{ accessModalMachine.registrationCode }}</td>
              </tr>
              <tr>
                <td>User</td>
                <td class="copiable">{{ accessModalMachine.user }}</td>
              </tr>
              <tr>
                <td>Password</td>
                <td class="copiable" @click="copyPassword(accessModalMachine.password)">{{ accessModalMachine.password }}</td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="grid has-gutter" v-if="accessModalMachine.service === 'EC2'">
          <div>
            <h3>macOS</h3>
            <a :href="`rdp://full%20address=s:${accessModalMachine.publicIp}:3389&username=s:${accessModalMachine.user}`"><button>Open Microsoft Remote Desktop</button></a>
            <br><br>
            <small>The Microsoft RDP software for Mac is available <a href="https://apps.apple.com/us/app/microsoft-remote-desktop-10/id1295203466?mt=12" target="_blank">here</a></small>
          </div>
        </div>
        <div v-else>
          <h3>Connect</h3>
          <a :href="`workspaces://${encodeURIComponent(accessModalMachine.user)}@${accessModalMachine.registrationCode}`"><button>Connect to the machine</button></a>
          <br><br>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { startCase } from 'lodash';

import Navbar from '@/components/Navbar';
import Modal from '@/components/Modal';
import Loading from '@/components/Loading';
import CircleState from '@/components/CircleState';
import OBWanServices from '@/utils/obwan-services';
import { setInterval, clearInterval } from 'timers';

export default {
  name: 'ProductionUnit',
  components: { Navbar, Loading, CircleState, Modal },
  methods: {
    startCase (str) {
      return startCase(str);
    },
    fetch() {
      if (!this.$route.params.id) {
        clearInterval(this.intervalRefresh);
        return;
      }
      OBWanServices.getProductionUnit(this.$route.params.id).then(productionUnit => {
        this.productionUnit = productionUnit;

        let startingMachines = 0;
        let stoppingMachines = 0;
        let stoppedMachines = 0;
        let erroredMachines = 0;
        let runningMachines = 0;

        for (let machine of this.productionUnit.machines) {
          if (machine.state === 'starting')        startingMachines++;
          else if (machine.state === 'pending')    startingMachines++;
          else if (machine.state === 'stopping')   stoppingMachines++;
          else if (machine.state === 'stopped')    stoppedMachines++;
          else if (machine.state === 'available')  runningMachines++;
          else if (machine.state === 'running')    runningMachines++;
          else                                     erroredMachines++;
        }

        if (startingMachines >= 1)
          this.productionUnitState = 'starting';
        if (stoppingMachines >= 1)
          this.productionUnitState = 'stopping';
        if (stoppedMachines === this.productionUnit.machines.length)
          this.productionUnitState = 'offline';
        if (runningMachines === this.productionUnit.machines.length)
          this.productionUnitState = 'online';
        if (erroredMachines >= 1)
          this.productionUnitState = 'offline';

        this.loading = false;
      });
    },
    startMachines() {
      this.productionUnitState = 'starting';
      OBWanServices.startProductionUnit(this.$route.params.id).then(start => {
        console.log(start)
      }).catch(error => {
        this.startingMachinesModal = true;
        this.startingMachinesError = error;
      });
    },
    stopMachines() {
      this.productionUnitState = 'stopping';
      OBWanServices.stopProductionUnit(this.$route.params.id).then(start => {
        console.log(start)
      }).catch(error => {
        this.stoppingMachinesModal = true;
        this.stoppingMachinesError = error;
      });
    },
    access (machine) {
      if (machine.service === 'EC2') this.accessModalTitle = `Microsoft RDP access instructions for ${machine.name}`;
      if (machine.service === 'WS') this.accessModalTitle = `PCoIP Workspace access instructions for ${machine.name}`;
      this.accessModalMachine = machine;
      this.accessModal = true;
    },
    copyPassword (password) {
      this.$copyText(password);
    }
  },
  data () {
    return {
      productionUnit: null,
      loading: true,
      productionUnitState: 'offline',
      startingMachinesModal: false,
      startingMachinesError: '',
      stoppingMachinesModal: false,
      stoppingMachinesError: '',
      accessModal: false,
      accessModalMachine: null,
      accessModalTitle: '',
      intervalRefresh: null
    }
  },
  mounted () {
    this.fetch();
    this.intervalRefresh = setInterval(() => this.fetch(), 10000);
  }
}
</script>
<style lang="scss" scoped>
.box {
    background-color: #393C44;
    border: 1px solid #4B505C;
    border-radius: 5px;
    padding: 240px 8vw 20px 8vw;
    min-height: calc(100vh - 170px);
    position: relative;

    header{
      background: url('../assets/control_room.jpg');
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% - 16vw);
      height: 170px;
      border-radius: 4px 4px 0 0;
      padding: 25px 8vw 20px 8vw;

      img {
        opacity: 0.25;
        display: inline-block;
      }

      .start-stop {
        position: absolute;
        right: 8vw;
        top: 90px;
      }
    }

    .machine {
      background: #525660;
      box-shadow: 0 2px 0 0 #23252A;
      border-radius: 4px;
      width: calc(100% - 10px);
      min-height: 70px;
      position: relative;
      padding: 20px 0 0 10px;
      margin-bottom: 15px;

      .icon {
        display: inline-block;
        height: 50px;
        width: 50px;
        margin-right: 25px;
        margin-left: 15px;
        vertical-align: top;
        img { width: 100%; }
      }

      .info {
        display: inline-block;
        .name {
          font-size: 18px;
          font-weight: 600;
        }
        .description {
          font-size: 12px;
          margin-top: 10px;

          span {
            vertical-align: top;
            display: inline-block;
            text-transform: uppercase;
            margin-left: 7px;
          }

        }
      }
      .access {
        position: absolute;
        top: 25px;
        right: 25px;
      }
  }
 }
 small {
   font-size: 12px;
 }
 pre {
   font-family: monospace;
 }
 h3 { margin-bottom: 10px; margin-top: 0; font-size: 16px; }
 table{
   margin: 0px 0px 30px 0px;
   width: 100%;
   border-collapse:collapse;
   tr{
     height: 40px;
     border-bottom: 1pt solid rgba(255, 255, 255, 0.2);
     td:first-child{
       width: 25%;
     }
     td:last-child{
       font-weight: bold;
     }
   }
 }
 .copiable {
   cursor: pointer;
   &:hover {
     opacity: 0.9;
     text-decoration: underline;
   }
   &:active {
     opacity: 0.5;
   }
 }
</style>


